import { BasicPrivateOfferVO } from "./BasicPrivateOfferVO";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 24.04.13
 * Time: 16:11
 */

import { IOfferDescriptionVisualParameter } from "./offerDescriptions/visualizations/IOfferDescriptionVisualParameter";

/**
 * Class to store failed visual execution of Offer Visual Parameter
 */
export class OfferFailedVisualExecution {
    public tries: number = 0;
    public offerVO: BasicPrivateOfferVO;
    public visualParameter: IOfferDescriptionVisualParameter;

    constructor(tries: number, offerVO: BasicPrivateOfferVO, visualParameter: IOfferDescriptionVisualParameter) {
        this.tries = tries;
        this.offerVO = offerVO;
        this.visualParameter = visualParameter;
    }
}

